import React from "react";
import PropTypes from "prop-types";

// components
import BestValue from "core/BestValue";
import Flexbox from "core/Flexbox";
import LicenseRadio from "core/LicenseRadio";

// styles
import { LicenseRadioContainer } from "subscriptions/styles";

// data
import {
    licenseType,
    PRO_MONTHLY_PLAN,
    PRO_YEARLY_PLAN,
    TEAM_MONTHLY_PLAN,
    TEAM_YEARLY_PLAN
} from "subscriptions/data";

import {
    YEARLY_SUBSCRIPTION_PLAN_NAME,
    MONTHLY_SUBSCRIPTION_PLAN_NAME,
    SUBTEXT_ANNUAL_PLAN_AS_MONTHLY,
    SUBTEXT_MONTHLY_PLAN
} from "core/constants";
import { truncateToDecimals } from "frontend/components/helpers";

const SubscriptionLicenseBtns = ({
    setLicenseSelection,
    subscriptionPrices,
    licenseSelection,
    teamCheckout
}) => {
    const MonthlyPlanType = teamCheckout ? TEAM_MONTHLY_PLAN : PRO_MONTHLY_PLAN;
    const YearlyPlanType = teamCheckout ? TEAM_YEARLY_PLAN : PRO_YEARLY_PLAN;

    const YearlyBestValue = () => (
        <Flexbox flexDirection="column">
            {YEARLY_SUBSCRIPTION_PLAN_NAME}
            <BestValue leftMargin={false} />
        </Flexbox>
    );

    const yearlySchema = {
        id: YearlyPlanType,
        selected: licenseSelection === YearlyPlanType,
        title: <YearlyBestValue />,
        ariaLabel: YEARLY_SUBSCRIPTION_PLAN_NAME,
        price: "$" + truncateToDecimals(subscriptionPrices.yearly / 12),
        attributionDisclaimer: "",
        meta: {},
        link: <></>,
        onClick: () => setLicenseSelection(YearlyPlanType)
    };

    const monthlySchema = {
        id: MonthlyPlanType,
        selected: licenseSelection === MonthlyPlanType,
        title: MONTHLY_SUBSCRIPTION_PLAN_NAME,
        ariaLabel: MONTHLY_SUBSCRIPTION_PLAN_NAME,
        price: "$" + truncateToDecimals(subscriptionPrices.monthly),
        attributionDisclaimer: "",
        meta: {},
        link: <></>,
        onClick: () => setLicenseSelection(MonthlyPlanType)
    };

    return (
        <LicenseRadioContainer>
            <LicenseRadio
                schema={yearlySchema}
                type={licenseType}
                priceSubText={SUBTEXT_ANNUAL_PLAN_AS_MONTHLY}
            />

            <LicenseRadio
                schema={monthlySchema}
                type={licenseType}
                priceSubText={SUBTEXT_MONTHLY_PLAN}
            />
        </LicenseRadioContainer>
    );
};

SubscriptionLicenseBtns.propTypes = {
    setLicenseSelection: PropTypes.func.isRequired,
    subscriptionPrices: PropTypes.shape({
        yearly: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        monthly: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }).isRequired,
    licenseSelection: PropTypes.string.isRequired,
    teamCheckout: PropTypes.bool
};

export default SubscriptionLicenseBtns;
